/**
 * Verifica se o email tem um dos dois dominios (Yourviews `@yourviews.com.br` ou Hi Platform `@hiplatform.com`) e retorna `true` caso sim.
 *
 * @param {string} email Email a ser testado se possui um dos dois dominios
 */
const isHiOrYvEmail = (email) =>
  email.includes('@yourviews.com.br') || email.includes('@hiplatform.com')

export default isHiOrYvEmail
